module.exports = __webpack_public_path__ + "pc-top-assets/img/search.2e519413.svg";